<template lang="html">
  <VqModal
    :name="modalName"
    class="vq-modal-delete-vm">
    <template v-slot:header>
      <h2 class="modal-title"><span class="is-bold">{{ $t('components.modalActionVm.vm') }} {{vm.name}}</span></h2>
      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>
    <template v-slot:content>
      <div class="forms">
        <form>
          <div class="container has-separator">
            <div>
              <p class="pb-10">
                {{ $t('components.modalActionVm.content') }} <span class="is-bold">"{{vm.name}}": </span>{{actionName}}
              </p>
            </div>
          </div>
        </form>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalActionVm.close') }}</button>
      <button
        type="button"
        class="button is-small is-danger is-outline"
        @click="submit">{{ $t('components.modalActionVm.submit') }}
      </button>
    </template>
  </VqModal>
</template>

<script lang="js">

import { eventHubMixin } from '@/mixins/event';

import VSPHERE from '@/api/vsphere';

import VqModal from '@/components/VqModal.vue';


export default {
  name: 'ModalActionVm',
  mixins: [eventHubMixin],
  components: {
    VqModal,
  },

  data() {
    return {
      modalName: 'action-vm',
      vm: {},
      action: '',
    };
  },
  mounted() {
    this.onOpenModal(this.modalName, (data) => {
      this.vm = data.vm
      this.action = data.action
    });
  },
  methods: {
    submit() {
      VSPHERE.action({vcenter_id: this.vm.vcenter_id, uuid: this.vm.uuid, action: this.action}).then(
        (res) => {
          this.close();
          this.emitToaster();
        },
        (err) => {
          Object.assign(this.errors, err.response.data);
        },
      );
    },
    close() {
      this.emitCloseModal(this.modalName);
    },
    emitToaster() {
      this.emitAddToaster({
        title: this.$t('components.modalActionVm.toasts.title'),
        text: `${this.$t('components.modalActionVm.vm')} ${this.vm.name} ${this.actionName} ${this.$t('components.modalActionVm.toasts.content')}`,
        state: 'success',
      });
    },
  },
  computed: {
    actionName() {
      if (this.action === 'powerOn') {
        return this.$t('components.modalActionVm.power')
      } else if (this.action === 'reset') {
        return this.$t('components.modalActionVm.reset')
      } else {
        return this.$t('components.modalActionVm.restart')
      }
    }
  },
};
</script>
